export default {"src":"/_next/static/media/Illustrated-Locations.7e9c4fc4.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};